import { useQuery } from 'react-query'
import { useMemo } from 'react'
import { Article, ReducedArticle } from '../types/entities'
import { zendeskAPI } from '../config/routes'
import { QueryKeys } from '../api/queryKeys'
import { fetchData } from '../utils'
import { mapTopArticles } from '../utils/mapTopArticles'

type TopArticlesResponse = {
  articles: Article[]
}

type FetchTopArticlesResult = {
  topArticlesError: unknown,
  isTopArticlesFetching: boolean,
  topArticles: ReducedArticle[] | undefined,
}

const useFetchTopArticles = (limit?: number): FetchTopArticlesResult => {
  const {
    error: topArticlesError,
    data: topArticlesResponse,
    isLoading: isTopArticlesFetching,
  } = useQuery<TopArticlesResponse>(
    QueryKeys.TOP_ARTICLES,
    () => fetchData(zendeskAPI.topArticles),
  )

  const topArticles = useMemo(() => {
    const articles = topArticlesResponse?.articles

    return articles && mapTopArticles(articles, limit)
  }, [topArticlesResponse, limit])

  return {
    topArticlesError,
    isTopArticlesFetching,
    topArticles,
  }
}

export { useFetchTopArticles }
export type { FetchTopArticlesResult }
